import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'meeting-analysis-statistic',
  styleUrls: ['./statistic.component.scss'],
  template: `<span
    class="statistic"
    [ngClass]="{
      green: scorePercentage() > 70,
      yellow: scorePercentage() > 50 && scorePercentage() <= 70,
      red: scorePercentage() <= 50,
    }"
    >{{ score() }}</span
  >`,
  imports: [CommonModule],
})
export class StatisticComponent {
  score = input<number>(0);
  maxScore = input<number>(10);

  scorePercentage = computed(() => {
    return (this.score() / this.maxScore()) * 100;
  });
}
